export default __webpack_public_path__ + "static/media/Redux Shop (2).be38916b.png";